import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/Consignments/actions";
import { Field, formValueSelector } from "redux-form";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { properCase } from "LIB/formatters/text";
import { Col, FormGroup } from "react-bootstrap";
import {
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNOR_PERCENTAGE
} from "MODULES/Receiving/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import { BUYER_ID, CO_BUYER_ID, USER } from "MODULES/users/constants";
import {
  CONDITION,
  STORE_LOCATION,
  STORE_LOCATION_ID,
  STORE_OWNER,
  STORE_OWNER_ID
} from "MODULES/inventories/constants";
import { searchParts } from "MODULES/parts/actions";
import * as poActions from "MODULES/PurchaseOrders/actions";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import BuyingStoreRadioField from "MODULES/Locations/components/BuyingStoreRadioField";
import BuyerField from "../../../PurchaseOrders/shared/CoBuyersFields/BuyerField";
import ConsignmentOrEmaRadioField from "./ConsignmentOrEmaRadioField";
import validate from "./validate";

export function Form(props) {
  const [selectedConsignmentBuyer, setSelectedConsignmentBuyer] = useState(
    null
  );
  const [selectedConsignmentCoBuyer, setSelectedConsignmentCoBuyer] = useState(
    null
  );
  const [selectedConsignor, setSelectedConsignor] = useState(null);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name={CONSIGNMENT_REFERENCE}
              component={FormInput}
              label="Create Ref #"
              required
            />
          </Col>
          <Col md={6}>
            <ConsignmentOrEmaRadioField />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={3}>
            <Field
              name={CONSIGNMENT_REFERENCE_COMPANY_ID}
              label="Consignment Ref Co."
              placeholder="Search by a company's name"
              component={AutoCompleteField}
              onItemSelected={item => setSelectedConsignor(item)}
              search={props.searchCompanies}
              selectedItem={selectedConsignor}
              formatItem={result => result && result.name}
              required
            />
          </Col>
          <Col md={2}>
            <FormGroup>
              <Field
                label="Consignor %"
                name={CONSIGNOR_PERCENTAGE}
                component={FormInput}
                type="number"
                inputProps={{
                  min: 0,
                  max: 100
                }}
                required
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <BuyerField
                label="Cons. Buyer Credit"
                name={BUYER_ID}
                searchBuyers={props.searchBuyers}
                selectedBuyer={selectedConsignmentBuyer}
                onItemSelected={item => setSelectedConsignmentBuyer(item)}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <BuyerField
                label="Cons. Co Buyer Credit"
                name={CO_BUYER_ID}
                required={false}
                searchBuyers={props.searchBuyers}
                selectedBuyer={selectedConsignmentCoBuyer}
                onItemSelected={item => setSelectedConsignmentCoBuyer(item)}
              />
            </FormGroup>
          </Col>
        </FormRow>
        <FormRow>
          <Col md={4}>
            <BuyingStoreRadioField
              label={properCase(STORE_OWNER)}
              name={STORE_OWNER_ID}
              required
            />
          </Col>
          <Col md={4}>
            <BuyingStoreRadioField
              label={properCase(STORE_LOCATION)}
              name={STORE_LOCATION_ID}
              required
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  country: PropTypes.string
};

const FORM_NAME = "createConsignment";

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    currentUser: state.session.get(USER),
    condition: selector(state, CONDITION)
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.create(data)),
    queryParts: filter => dispatch(searchParts(filter)),
    searchBuyers: filter => dispatch(poActions.searchBuyers(filter)),
    searchCompanies: filter => dispatch(poActions.searchCompanies(filter))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/Consignments/Search/Create/Form.jsx